import { LogicalOperator } from "@unlikelyai-magic/shared/data-access/api";
import { cn } from "@unlikelyai-magic/utils";

export const LogicalOperatorPill = ({
  operator,
  className,
}: {
  operator: LogicalOperator;
  className?: string;
}) => {
  const backgroundColor =
    operator === LogicalOperator.AND
      ? "bg-green-500"
      : operator === LogicalOperator.OR
        ? "bg-blue-500"
        : "bg-red-500";
  return (
    <div
      className={cn(
        "flex items-center justify-center w-fit px-2 py-1 rounded-lg text-white",
        backgroundColor,
        className
      )}
    >
      <span className="font-semibold text-xs">{operator}</span>
    </div>
  );
};
